// src/components/pdf/AssessmentPDF.js
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "../../assets/company-logo.png";
import signature from "../../assets/signature.png";

/**
 * Generate Assessment PDF
 * @param {Object} data - Full assessment payload
 * @param {("download"|"view")} [mode="download"] - Mode for PDF output
 */
const generateAssessmentPDF = (data, mode = "download") => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();

  // ✅ Header with logo
  doc.addImage(logo, "PNG", 10, 3, 30, 30);
  doc.setFontSize(10);
  doc.text("VIJAYA DIAGNOSTIC CENTER LIMITED", pageWidth - 10, 15, { align: "right" });
  doc.text("3-6-16 & 17, Street #19, Himayathnagar, Hyderabad -500 029", pageWidth - 10, 20, { align: "right" });
  doc.text("Email: info@vijayadiagnostic.com | Customer Care: 040-2100 0000", pageWidth - 10, 25, { align: "right" });

  doc.setFontSize(14);
  doc.setFont("helvetica", "bold");
  doc.text("RADIOLOGY DOCTOR - INTERVIEW ASSESSMENT SHEET", pageWidth / 2, 40, { align: "center" });

  // ===============================
  // 1. Candidate Info
  // ===============================
  const candidate = data.candidate || {};
  const candidateInfo = [
    ["Candidate ID", candidate.id || "-"],
    ["Candidate Name", candidate.candidate_name || "-"],
    ["Position Applied", candidate.position_applied || "-"],
    ["Mobile", candidate.mobile || "-"],
    ["Email", candidate.email || "-"],
  ];

  autoTable(doc, {
    startY: 50,
    head: [["Particulars", "Details"]],
    body: candidateInfo,
    theme: "grid",
    headStyles: { fillColor: [44, 62, 80] },
  });

  // ===============================
  // 2. Regions
  // ===============================
  if (data.regions?.length) {
    const finalY = doc.lastAutoTable.finalY + 10;
    const regionBody = data.regions.map((r, idx) => [idx + 1, r.region_name, r.branch_name]);

    autoTable(doc, {
      startY: finalY,
      head: [["#", "Region Name", "Branch Name"]],
      body: regionBody,
      theme: "grid",
      headStyles: { fillColor: [88, 99, 110] },
    });
  }

  // ===============================
  // 3. Modalities & Submodalities
  // ===============================
if (data.modalities?.length) {
  const filteredModalities = data.modalities.filter(
    (m) => m.level && m.level.trim() !== ""
  );

  if (filteredModalities.length > 0) {
    const finalY = doc.lastAutoTable.finalY + 10;
    const modBody = filteredModalities.map((m, idx) => [
      idx + 1,
      m.modality,
      m.selection_area,
      m.level,
    ]);

    autoTable(doc, {
      startY: finalY,
      head: [["#", "Modality", "Item", "Classification"]],
      body: modBody,
      theme: "grid",
      headStyles: { fillColor: [52, 73, 94] },
    });
  }
}

  // ===============================
  // 4. Personality Assessments
  // ===============================
  if (data.personality_assessments?.length) {
    const finalY = doc.lastAutoTable.finalY + 10;
    const paBody = data.personality_assessments.map((p, idx) => [
      idx + 1,
      // p.assessment_date,
      p.criteria,
      // p.rating,
      p.remarks,
    ]);

    autoTable(doc, {
      startY: finalY,
      head: [["#", "Criteria", "Remarks"]],
      body: paBody,
      theme: "grid",
      headStyles: { fillColor: [66, 99, 144] },
    });
  }

  // ===============================
  // 5. Technical Evaluations
  // ===============================
  if (data.technical_evaluations?.length) {
    const finalY = doc.lastAutoTable.finalY + 10;
    const teBody = data.technical_evaluations.map((t, idx) => [
      idx + 1,
      t.particular,
      t.assessment,
      t.notes,
    ]);

    autoTable(doc, {
      startY: finalY,
      head: [["#","Particular", "Assessment", "Notes"]],
      body: teBody,
      theme: "grid",
      headStyles: { fillColor: [99, 66, 77] },
    });
  }

  // ===============================
  // 6. Signature Section
  // ===============================
  const finalY = doc.lastAutoTable?.finalY || 60;

// 📌 Evaluator Signature
doc.addImage(signature, "PNG", 14, finalY + 20, 30, 15);

doc.setFontSize(12);
doc.setFont("helvetica", "normal");
doc.text(candidate.rm_name, 14, finalY + 40);

doc.setFontSize(10);
doc.setFont("helvetica", "italic");
doc.text("(Director | HOD - Radiology)", 14, finalY + 45);

doc.setFontSize(10);
doc.setFont("helvetica", "italic");
doc.text(
  "I hereby confirm that proper and detailed screening is done for the doctor considering VDCL requirements and accordingly, hiring decision is confirmed.",
  14,
  finalY + 53,
  { maxWidth: pageWidth - 28 }
);
doc.text(
  `Manager Approved Date: ${candidate.manager_approved_date}`,
  14,
  finalY + 63,
  { maxWidth: pageWidth - 28 }
);

// // 📌 Additional Signature (e.g., Approval Authority)
// doc.addImage(signature, "PNG", 14, finalY + 70, 30, 15);

// doc.setFontSize(12);
// doc.setFont("helvetica", "normal");
// doc.text("Approving Authority Signature", 14, finalY + 89);

// doc.setFontSize(10);
// doc.setFont("helvetica", "italic");
// doc.text(
//   "(Regional Medical Officer / Zonal Head)",
//   14,
//   finalY + 94
// );
if (candidate.hr_status === 'Approved') {
// 📌 Recruiter Signature
doc.addImage(signature, "PNG", 14, finalY + 80, 30, 15);

doc.setFontSize(12);
doc.setFont("helvetica", "Normal");
doc.text(candidate.hr_name, 14, finalY + 100);
doc.setFontSize(10);
doc.setFont("helvetica", "italic");
doc.text("(Recruiter Name & Signature)", 14, finalY + 105);

doc.setFontSize(10);
doc.setFont("helvetica", "italic");

doc.text(
  "I hereby confirm that the required reports are collected from the Doctor (Candidate) and added as part of recommendation for the approval process. Eventually, this report shall be added to the personnel file records after Onboarding of the Doctor (Candidate).",
  14,
  finalY + 115,
  { maxWidth: pageWidth - 28 }
);
doc.text(
  `Hr Approved Date: ${candidate.hr_approved_date}`,
  14,
  finalY + 127,
  { maxWidth: pageWidth - 28 }
);
}

  // ✅ Save or View
  if (mode === "download") {
    doc.save(`Assessment_${candidate.candidate_name || "Candidate"}.pdf`);
  } else {
    window.open(doc.output("bloburl"));
  }
};

export default generateAssessmentPDF;